import React, {useEffect, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Checkbox, Grid} from '@mui/material';
// component imports
import moment from 'moment';
import {AddButton} from 'Components/Table';
import { Table, SearchInput } from 'Components/uiControls';
import Modal, {ModalBody, ModalFooter} from 'Components/Modal';
import {MenuComponent} from 'Components/Menu';
import {Tooltip} from 'Components';
import Form from 'Components/Form';
import {TableButtons} from 'Components/uiControls/Table';
import {GetFormatForMoment} from 'Core/data/Helpers';

import Button from 'Components/Button';
import {useIntl} from 'react-intl';
// actions
import {deleteSchedule, getSchedules} from 'Redux/actions'
import {NotificationManager} from 'Components/Notifications';
import VirtualizedTable from "Components/uiControls/VirtualizedTable";
import {usePagination} from "Components/uiControls/Table/hooks";
import {
  getSchedule,
  reportsScheduleShowReportSetup
} from "Modules/reports/views/main/components/scheduleTab/.components/reportSetup/redux/actions";
import {sendGenericExport} from "Core/common/redux/actions";

import { getReportTypeName } from '../../../../.globals/helpers';

const formatSchedule = (schedule) => {
  return (String(schedule?.format || '').toLocaleLowerCase() === 'json' ? 'WEB' : schedule?.format) || ''
}
const getColumns = (messages, handleOptions, loading, timeZone, dateformat = "YYYY/MM/DD") => {

  return [
    {
      key: 'name',
      show: true,
      title: messages['reportsMainST_title'],
      export: true,
      functionString: 'return row?.name'
    },
    {
      key: 'reportType',
      show: true,
      title: messages['reportsMainST_type'],
      export: true,
      functionString: 'return row?.reportType'
    },
    {
      key: 'frequency',
      show: true,
      title: messages['reportsMainST_frequency'],
      export: true,
      functionString: `
          return row?.frequency`
    },
    {
      key: 'deliveryAt',
      show: true,
      title: messages['reportsMainST_deliveredAt'],
      export: true,
      functionString: 'return row?.deliveryAt'
    },
    {
      key: 'format',
      show: true,
      title: messages['reportsMainST_format'],
      export: true,
      functionString: 'return (String(row?.format || \'\').toLocaleLowerCase() === \'json\' ? \'WEB\' : row?.format.toLocaleUpperCase()) || \'\''
    },
    {
      key: 'subscribersTxt',
      show: true,
      title: messages['reportsMainST_subscribers'],
      export: true,
      functionString: `
            if (row.ftpHostType){
              return row.ftpHostType.toUpperCase()
            } else {
              let txt = row?.subscribersTxt || '';
              return txt;
            }
            `,
    },
    {
      key: 'nextDelivery',
      show: true,
      title: messages['reportsMainST_nextReport'],
      export: true,
      functionString: 'return row?.nextDelivery'
    }
  ];
}


const ScheduledTab = (props) => {
  const {clearOldData} = props;
  const [searchText, setSearchText] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const [exclusionsItems, setExclusionsItems] = useState([])
  const [openDelete, setOpenDelete] = useState(false);

  const [rowsToDelete, setRowsToDelete] = useState([]);
  const [rowToExcludes, setRowToExcludes] = useState([]);

  const frmDeleteSchedule = useRef();
  const dispatch = useDispatch();
  const { messages } = useIntl();

  let schedules = useSelector(state => state.reportsMainSTRedux.schedules);
  const deletedSchedule = useSelector(state => state.reportsMainSTRedux.deletedSchedule);
  const { timeZone, dateformat } = useSelector(state => state.securityRedux.user);
  let loadingSchedules = useSelector(state => state.reportsMainSTRedux.loadingSchedules);

  const [selectedAll, setSelectedAll] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [resetCache, setResetCache] = useState(0);

  const tableRef = useRef();
  const pagination = usePagination(tableRef, getSchedules);

  useEffect(() => {
    dispatch(getSchedules(messages, timeZone));
  }, []);

  useEffect(() => {
    if (schedules?.items?.length) {
      setResetCache(prev => prev + 1);
    }
  }, [schedules?.items]);

  useEffect(() => {
    const handleResize = () => {
      setResetCache(prev => prev + 1);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {

    if (deletedSchedule) {
      NotificationManager.success(
        messages['success'],
        messages['reportsMainST_deleteSchedule'],
        3000,
        null,
        null,
        'warning',
        null
      );
      dispatch(getSchedules(messages, timeZone));
      setSelectedItems([]);
      setExclusionsItems([])
      setOpenDelete(false)
      setRowsToDelete([]);
      setRowToExcludes([])
      onChangeSearchText("");
    }
  }, [deletedSchedule]);

  const onChangeSearchText = (newSearchText) => {
    setSearchText(newSearchText)
    setFilterData({... schedules, items: schedules.items?.filter((data) => data.name.toLowerCase().includes(newSearchText.toLowerCase()))})
    setSelectedItems([])
    setExclusionsItems([])
  }

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleOptions = (type, schedule) => {
    if (type === 'Delete' || type === 'Eliminar') {
      setOpenDelete(true)
      setRowsToDelete([schedule])
      setRowToExcludes(exclusionsItems.concat())
    } else if (type === 'Edit' || type === 'Editar') {
      dispatch(getSchedule(schedule.id))
      dispatch(reportsScheduleShowReportSetup())

    }
  }

  const getDataToExport = (rows, type) => {
    let data = [];
    const currentList = selectedItems.length ? selectedItems : rows;
    currentList.forEach((schedule) => {
      const subscribers = schedule?.subscribersTxt;
      data.push([
        deleteComma(schedule.name, type),
        schedule.reportType,
        deleteComma(schedule.frequency, type),
        deleteComma(schedule.deliveryAt, type),
        deleteComma(formatSchedule(schedule), type),
        deleteComma(subscribers, type),
        schedule.nextExecution
      ]);
    });
    return data;
  }

  const deleteComma = (string, type) => {
    if (string && type == 'csv') {
      return String(string).replaceAll(',', ' - ')
    }
    return string;
  }

  const TimeframeLabel = (label) => {
    switch (label) {
      case 'Daily':
        return messages['daily']

      case 'Weekly':
        return messages['weekly']

      case 'Weekly':
          return messages['weekly']

      case 'Monthly':
        return messages['reportsMainST_monthly']

      default:
        return messages['daily']
    }
  }

  const renderItems = (parameters) => {
      return <TableViewSchedules {...parameters}></TableViewSchedules>;
  }

  const TableViewSchedules = ({index, style, content, id, previousItem}) => {
    const menuScheduleOptions = [messages['edit'], messages['delete']];

    const labels = content?.deliveryAt.split(',');
    let format = [];
    labels.map((lab, index) => {
      let traductor = ''
      if (index === (labels.length - 1)){
        if (lab.includes('at') && !lab.includes('saturday')){
          const end = lab.split('at')
          const data = messages[`vehicleStatusModal_${end[0].trim()}`];
          traductor = data ? data : end[0].trim() + ` ${messages['at_time']} ${end[1]}`
        } else if (lab.includes('saturday')) {
          const day = lab.split('saturday')
          const end = day[1].split('at')
          traductor =  messages['vehicleStatusModal_saturday'] + ` ${messages['at_time']} ${end[1]}`
        } else {
          traductor =  lab !== 'saturday' ? lab :  messages['vehicleStatusModal_saturday']
        }
      } else if (lab) {
        const data = messages[`vehicleStatusModal_${lab}`];
        traductor = data ? data : lab
      } else {
        traductor = lab
      }
      format.push(traductor);
    })

    let txt = content?.subscribersTxt

    if (content.ftpHostType){
      txt = content.ftpHostType.toUpperCase()
    }

      return (
        <div
            className="listItem homeItemReport content-item-reports-home"
            style={style}
            id={id}
        >
          <Grid container direction={"column"} className={"container-row-schedule-home"}>
            <Grid container item  direction={"row"} style={{paddingTop: "1px", paddingBottom: "1px"}}>
              <Grid item className={"report-ctn-text"} sm={1}>
                <Checkbox
                    style={{ color: "black", zIndex: 0 }}
                    className={'checkbox-table-select'}
                    checked={
                        selectedItems.findIndex(x => x.id === content.id || x === content) > -1 || (
                        selectedAll && !(exclusionsItems.findIndex(x => x.id === content.id || x === content) > -1))
                    }
                    onChange={() => {
                        let newSelectedItems = selectedAll ? exclusionsItems.concat() : selectedItems.concat();

                      let indexCheck = newSelectedItems.findIndex(x => x.id === content.id || x === content)

                      if (indexCheck > -1){
                        newSelectedItems.splice(indexCheck, 1)
                      }else{
                        newSelectedItems.push(content)
                      }

                       selectedAll ? setExclusionsItems(newSelectedItems) : setSelectedItems(newSelectedItems)
                    }}
                    inputProps={{'aria-label': 'select all desserts'}}
                    size="small"
                />
              </Grid>
              <Grid item className={"report-ctn-text"} sm={1.4}>

                <Grid container alignItems="center" className="schedule-report-title-ctn" spacing={1} sx={{minWidth: '150px'}}>
                  <Grid item sm={8}>
                    <Tooltip placement="right" title={content?.name} >
                      <span className="schedule-report-title">{content?.name?.length > 20 ? `${content?.name.slice(0, 20)}...` : content?.name}</span>
                    </Tooltip>

                  </Grid>
                  <Grid item sm={4}>
                    <MenuComponent
                        options={menuScheduleOptions}
                        icon={'more_vert'}
                        className="icon-menu-vehicle-service schedule-report-title-ctn-showInHoverMenu"
                        onClick={handleOptions}
                        value={content}
                        disabled={loadingSchedules}
                    />
                  </Grid>
                </Grid>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={1}>

                <span className="">{ getReportTypeName(content?.reportType, messages) || ''}</span>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={1.2}>

                <span className="">{TimeframeLabel(content?.frequency) || ''}</span>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={1.2}>

                <span className="">{format.join() || ''}</span>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={1}>

                <span className="">{formatSchedule(content)}</span>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={3.7}>

                <span >{txt || ''}</span>

              </Grid>
              <Grid item className={"report-ctn-text"} sm={1.3}>

                <span className=""> {
                  moment(new Date(content.nextExecution)).format(GetFormatForMoment(dateformat)+' hh:mm A')
                }</span>

              </Grid>
            </Grid>
          </Grid>
        </div>
    )
  }

  const columns = getColumns(messages, handleOptions, loadingSchedules, timeZone, dateformat);

  return (
    <>
      <HeaderSchedule
          onChangeSearchText={onChangeSearchText}
          addNewScheduleReport={() => {
            clearOldData()
            dispatch(reportsScheduleShowReportSetup())
            // dispatch(clearRedux("ENTITY_TAG_PICKER"));
          }}
          searchText={searchText}
          messages={messages}
          tableRef={tableRef}
          handleDeleteSchedule={() => {
            if (selectedItems?.length > 0) {
              setOpenDelete(true)
              setRowsToDelete(selectedAll ? ['-99'] : selectedItems.concat())
            } else {
              setOpenDelete(true)
              setRowToExcludes(exclusionsItems.concat())
          }
        }}
        countSchedulesSelected={((selectedItems.length > 0 || exclusionsItems.length > 0) || selectedAll)}
        countSchedules={schedules?.items?.length || 0}
        pagination={pagination}
        selectedItems={selectedItems}
        dispatch={dispatch}
      />

      <Grid item sm={12} style={{overflowX: "auto"}}>
        <Grid  container xs={12} item  direction={"row"} className={`container-headers-schedule-home ${messages['at'] === "a las" && "container__table_large" }`}>
          <Grid item  sm={1} className={'reports-cut-text'}>
            <Checkbox
                style={{color: "black", zIndex: 0}}
                className={'checkbox-table-select'}
                disabled={!schedules?.items?.length}
                indeterminate={selectedItems.length > 0 || exclusionsItems.length > 0}
                checked={selectedAll}
                onChange={() => {
                  setSelectedItems([])
                  setExclusionsItems([])
                  if(selectedItems.length > 0 && !selectedAll){
                    setSelectedAll(false)
                  }else{
                      setSelectedAll(!selectedAll)
                  }
                }}
                inputProps={{'aria-label': 'select all desserts'}}
                size="small"
            />
          </Grid>
          <Grid item sm={1.4} className={'reports-cut-text'}>
            {messages['reportsMainST_title']}
          </Grid>
          <Grid item sm={1} className={'reports-cut-te xt'}>
            {messages['reportsMainST_type']}
          </Grid>
          <Grid item sm={1.2} className={'reports-cut-text'}>
            {messages['reportsMainST_frequency']}
          </Grid>
          <Grid item sm={1.2} className={'reports-cut-text'}>
            {messages['reportsMainST_deliveredAt']}
          </Grid>
          <Grid item sm={1} className={'reports-cut-text'}>
            {messages['reportsMainST_format']}
          </Grid>
          <Grid item sm={3.7} className={'reports-cut-text'}>
            {messages['reportsMainST_subscribers']}
          </Grid>
          <Grid item sm={1.3} className={'reports-cut-text'}>
            {messages['reportsMainST_nextReport']}
          </Grid>
        </Grid>

        <div className={'hide-table-schedule'}>
          <Table
              ref={tableRef}
              data={schedules?.items || []}
              loading={loadingSchedules}
              keyColumn="id"
              hideHeader
              topheight={300}
              columns={columns}
              searchText={searchText}
              getDataToExport={getDataToExport}
              fixHeader
              hideTotal
              hidePerPage
              hidePagination
              hideAllInPagination
              hideDragable
              exportOrientation='landscape'
              exportName={messages['reportsMainST_scheduleList']}
              className={'hide-table-schedule'}
              messageNoData={messages['reportsMainST_withoutSchedules']}
              onSelectedItems={(newSelectedItems) => {
                setSelectedItems(newSelectedItems)
              }}
          />
        </div>

        <VirtualizedTable
            container={tableRef}
            renderItems={renderItems}
            isNextPageLoading={loadingSchedules}
            data={searchText !== '' ? filterData?.items : schedules?.items || []}
            total={schedules?.total}
            handleNewPageLoad={() => {
            }}
            noDataMessage={messages['reportsMainST_withoutSchedules']}
            containerClass={`container-virtualized-schedule-home ${messages['at'] === "a las" && "container__table_large" }`}
            resetCache={resetCache}
        />
      </Grid>

      <Modal
        size={'small'}
        open={openDelete}
        handleClose={handleCloseDelete}
        title={`${messages['delete']}`}
      >
        <ModalBody>
          <div style={{ padding: '0px 25px' }}>
            <Form ref={frmDeleteSchedule}
                  onValidSubmit={
                    () => {
                        setSelectedAll(false);
                        if(selectedItems?.length || rowsToDelete?.length){
                            dispatch(
                              deleteSchedule({ids: rowsToDelete?.map((item) => item.id)})
                            )
                        }else{
                            dispatch(
                              deleteSchedule({ids: ['-99'], idsExclusions: rowToExcludes?.map((item) => item.id)})
                            )
                        }
                    }
                  }
            >
              <p style={{ overflowWrap: 'anywhere' }}>
                  {selectedAll
                    ? rowToExcludes?.length
                        ? rowToExcludes?.length > 1
                        ? messages['reportsMainST_deleteExclusionsSchedulesMessage']
                        : messages['reportsMainST_deleteExclusionsScheduleMessage']
                    :  messages['reportsMainST_deleteAllScheduleMessage']
                    : rowsToDelete?.length > 1
                      ? messages['reportsMainST_deleteSchedulesMessage']
                      : messages['reportsMainST_deleteScheduleMessage']
                  }
              </p>
              <ul>
                {selectedAll || rowsToDelete.length > 0 &&
                  rowsToDelete.map((item) => {
                    return (
                      <li key={item.id}>
                        {item.name}
                      </li>
                    )
                  })}
                  {exclusionsItems.length > 0 &&
                    exclusionsItems.map((item) => {
                        return (
                          <li key={item.id}>
                              {item.name}
                          </li>
                        )
                    })}
              </ul>
            </Form>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className='container-buttons-delete-modal-reports'>
            <Button
              id={'btn-cancel-schedule'}
              type="button"
              onClick={handleCloseDelete}
              className="btn-cancel"
            >
              {messages['cancel']}
            </Button>
            <Button
              id={'btn-schedule'}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                frmDeleteSchedule.current.submit();
              }}
              className="btn-blue"
              disabled={loadingSchedules}
            >
              {messages['delete']}
            </Button>
          </div>
        </ModalFooter>
      </Modal>
      {/* <ReportSetup messages={messages} /> */}
    </>
  )
}

const HeaderSchedule = ({
                          onChangeSearchText,
                          addNewScheduleReport,
                          searchText,
                          messages,
                          tableRef,
                          handleDeleteSchedule,
                          countSchedules,
                          countSchedulesSelected,
                          pagination,
                          selectedItems,
                          dispatch
                        }) => {
  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      alignItems="center"
  >
    <Grid item xs={12} sm={4} style={{display: "flex"}}>
      <AddButton icon="add_circle" tooltip={messages['reportsMainST_scheduleReport']} onClick={addNewScheduleReport}/>
      <AddButton icon="delete" tooltip={messages['delete']} onClick={handleDeleteSchedule}
                 className={!countSchedulesSelected ? 'disabled hidden-delete-schedule' : 'icon-button'}/>
      <TableButtons
          tableRef={tableRef}
          {...pagination}
          messages={messages}
          buttons={['export']}
          disabled={countSchedules < 1}
          onExport={(type) => {
              if (selectedItems?.length) {
                  if (type === "Csv") {
                      tableRef.current.exportCSV();
                  } else if (type === "Pdf") {
                      tableRef.current.exportPDF();
                  }
              } else {
                  const columns = tableRef.current?.columns
                  const headers = columns.filter(x => x.show && x.export).map(x => { return { header: x.title, column: x.key, functionString: x.functionString } }) || [];

                  dispatch(sendGenericExport(
                    "searchSchedule",
                    type,
                    `query searchSchedule ($openSearch: String, $offset: Int, $reportType: enumReportType, $activeOnly: Boolean, $limit: Int) {
                        searchSchedule (openSearch: $openSearch, offset: $offset, reportType: $reportType, activeOnly: $activeOnly, limit: $limit) {
                            items {
                                id
                                name
                                reportType
                                category {
                                    field
                                    value
                                    categoryName
                                    dataResultFilter
                                }
                                integerRanges {
                                    fields
                                    GTE
                                    LTE
                                }
                                dateRange {
                                    fields
                                    GTE
                                    LTE
                                    timeframeName
                                }
                                timeZone
                                frequency
                                weekDays
                                deliveryOn
                                includeWeekend
                                monthDays
                                deliveryAt
                                scheduleExpires
                                subscribers {
                                    id
                                    contactId
                                    alert
                                    alertBefore
                                    alertAfter
                                    createdOn
                                    createdBy
                                    updatedOn
                                    updatedBy
                                }
                                format
                                UIParams
                                stringValues {
                                    values
                                }
                                booleanValue
                                filterValues {
                                    field
                                    booleanValue
                                }
                                active
                                selectAll
                                nextExecution
                                nextDelivery
                                ftpHost
                                ftpHostType
                                createdOn
                                createdBy
                                updatedOn
                                updatedBy
                                subscribersTxt
                                scheduleTimeRanges {
                                    day
                                    starTime
                                    endTime
                                    createdOn
                                    createdBy
                                }
                            }
                            total
                            offset
                        }
                    }`,
                    {
                      "openSearch": searchText
                    },
                    headers,
                    {unit: 'px', size: 'A4', orientation: 'landscape', fontSize: 10}
                ));
              }
          }}
        />
      </Grid>

    <Grid item xs={12} sm={4} className="mb-10 text-right">
      <SearchInput
          placeholder={messages['search']}
          searchText={searchText}
          onSearchText={onChangeSearchText}
      />
    </Grid>
  </Grid>)
}
export default ScheduledTab;
